import React from 'react';

function EmployeeInfo({ employee, handleChange }) {
  return (
    <>
      <label>
        First Name:
        <input name="firstName" value={employee.firstName} onChange={handleChange} required />
      </label>
      <label>
        Middle Name:
        <input name="middleName" value={employee.middleName} onChange={handleChange} />
      </label>
      <label>
        Last Name:
        <input name="lastName" value={employee.lastName} onChange={handleChange} required />
      </label>
      <label>
        Category:
        <input name="category" value={employee.category} onChange={handleChange} required />
      </label>
      <label>
        Work Auth:
        <input name="workAuth" value={employee.workAuth} onChange={handleChange} required />
      </label>
      <label>
        Guest Code:
        <input name="guestCode" value={employee.guestCode} onChange={handleChange} />
      </label>
      <label>
        Designation:
        <input name="designation" value={employee.designation} onChange={handleChange} required />
      </label>
      <label>
        Access Level:
        <select name="role" value={employee.role} onChange={handleChange}>
          <option>admin</option>
          <option>employee</option>
          <option>employer</option>
        </select>
      </label>
      <label>
        Status:
        <select name="status" value={employee.status} onChange={handleChange}>
          <option>Active</option>
          <option>Inactive</option>
        </select>
      </label>
      <label>
        Start Date:
        <input type="date" name="startDate" value={employee.startDate} onChange={handleChange} />
      </label>
      <label>
        End Date:
        <input type="date" name="endDate" value={employee.endDate} onChange={handleChange} />
      </label>
    </>
  );
}

export default EmployeeInfo;
